import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderPackagingComponent } from './work-order-packaging.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// ============================================================================
// MATERIAL IMPORTS
// ============================================================================
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatStepperModule } from '@angular/material/stepper';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';

// ============================================================================
// FLEX LAYOUT
// ============================================================================
import { FlexModule, FlexLayoutModule } from '@angular/flex-layout';

// ============================================================================
// CT FRAMEWORK
// ============================================================================
import { CtButtonModule, CtFrameworkModule, DisableArrowKeysModule } from '@ctsolution/ct-framework';

// ============================================================================
// INTERNAL MODULES
// ============================================================================
import { StatusToggleComponentModule } from '../../../handling/order-handling-wizard/order-handling-wizard-components/status-toggle-component/status-toggle-component.module';
import { WorkOrderPackagingFormModule } from '../work-order-packaging-form/work-order-packaging-form.module';

/**
 * Modulo per il componente Work Order Packaging.
 * Gestisce la creazione di packaging da work order utilizzando Material Design.
 * 
 * NOTA: MatTableModule e MatSortModule sono OBBLIGATORI per il corretto funzionamento
 * della tabella con selezione multipla.
 */
@NgModule({
  imports: [
    // Angular Common
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    
    // Material Design Components - ORDINE IMPORTANTE
    MatCardModule,
    MatDividerModule,
    MatListModule,
    MatIconModule,
    MatLegacyDialogModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    MatLegacyProgressBarModule,
    MatLegacyButtonModule,
    MatLegacyChipsModule,
    MatLegacyMenuModule,
    MatLegacySelectModule,
    MatProgressSpinnerModule,
    
    // CRITICAL: Questi devono essere importati per la tabella
    MatTableModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatSortModule,
    MatStepperModule,
    
    // Flex Layout
    FlexModule,
    FlexLayoutModule,
    
    // CT Framework
    CtButtonModule,
    CtFrameworkModule,
    DisableArrowKeysModule,
    
    // Internal Modules
    StatusToggleComponentModule,
    WorkOrderPackagingFormModule
  ],
  declarations: [WorkOrderPackagingComponent],
  exports: [WorkOrderPackagingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class WorkOrderPackagingModule { }
